// extracted by mini-css-extract-plugin
module.exports = {"trailer":"fr","imgWrapper":"fs","thumbnail":"ft","isRental":"fu","playWrapper":"fv","playImg":"fw","title":"fx","iconWrapper":"fy","navArrow":"fz"};